module.exports = __webpack_public_path__ + "img/GQ.66e4fb14.svg";